import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const offerService = {
  getOffers: async (token) => {
    const res = await axios.get(`${API_URL}/api/admin/merchant-offers`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  getMerchantOffers: async (token) => {
    const res = await axios.get(`${API_URL}/api/merchant/offers`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  // Generic creator: accepts payload with either product_id or product_ids
  addOffer: async (token, offer) => {
    const res = await axios.post(`${API_URL}/api/admin/merchant-offers`, offer, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  // Helper: create offer for a single product
  addOfferForProduct: async (token, baseOffer, productId) => {
    const payload = { ...baseOffer, product_id: productId };
    const res = await axios.post(`${API_URL}/api/admin/merchant-offers`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data; // single offer row expected
  },
  // Helper: create offer for multiple products (one row per product)
  addOfferForProducts: async (token, baseOffer, productIds) => {
    const payload = { ...baseOffer, product_ids: productIds };
    const res = await axios.post(`${API_URL}/api/admin/merchant-offers`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data; // array of created rows expected
  },
  updateOffer: async (token, offerId, updates) => {
    const res = await axios.put(`${API_URL}/api/admin/merchant-offers/${offerId}`, updates, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  deleteOffer: async (token, offerId) => {
    await axios.delete(`${API_URL}/api/admin/merchant-offers/${offerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default offerService; 